import React, { useMemo } from "react";
import { TransportData, TripTransport } from "@/types/trip";
import { Trip } from "@/types/trip";
import useView from "@/stores/tripBuilder/useView";

// Location Components
import MiddleContent from "@tripbuilder/views/middle";

// Transport Components
import TransportContainer from "@tripbuilder/cat-transport/middle/TransportContainer";

interface TripMiddleContentProps {
  selectedFlight: TripTransport | null;
  setSelectedFlight: (flight: TripTransport | null) => void;
  deleteFlightFromTrip: (trip: Trip, transportData: TransportData) => void;
  setFlightModalOpen: (isOpen: boolean) => void;
}

const TripMiddleContent: React.FC<TripMiddleContentProps> = ({
  selectedFlight,
  setSelectedFlight,
  deleteFlightFromTrip,
  setFlightModalOpen,
}) => {
  const panel = useView((state) => state.panel);

  const middleContent = useMemo(() => {
    if (panel === "locations") {
      return <MiddleContent />;
    } else if (panel === "transport") {
      return (
        <TransportContainer
          selectedFlight={selectedFlight}
          setSelectedFlight={setSelectedFlight}
          deleteFlightFromTrip={deleteFlightFromTrip}
          setFlightModalOpen={setFlightModalOpen}
        />
      );
    }
  }, [
    panel,
    selectedFlight,
    deleteFlightFromTrip,
    setSelectedFlight,
    setFlightModalOpen,
  ]);

  return (
    <div className="w-[92%] min-w-[92%] max-w-[92%] h-[calc(100vh-9px)] middle-content">
      <div className="w-full h-full">{middleContent}</div>
    </div>
  );
};

export default TripMiddleContent;
